<div class="sidebar-header-wrapper" [ngClass]="{ 'main-title-hidden': hideMainTitleComputed() }">
  <div class="small-title-container">
    <div
      (click)="smallTitleClicked()"
      class="small-title flex items-center gap-2"
      [ngClass]="{ 'cursor-pointer': showBackButton() }"
      (mouseenter)="backButtonHovered.set(true)"
      (mouseleave)="backButtonHovered.set(false)"
    >
      <app-back-button-box
        [isHovered]="backButtonHovered()"
        [class]="{ hidden: !showBackButton() }"
      ></app-back-button-box>
      <ng-content select="[smallTitle]"></ng-content>
    </div>
    <ng-content select="[headerRight]"></ng-content>
  </div>

  <div #mainTitleContainer class="main-title" [ngClass]="{ hidden: hideMainTitleComputed() }">
    <ng-content select="[mainTitle]"></ng-content>
  </div>
</div>
